import { FunctionComponent } from 'react'
import { useTranslation } from 'react-i18next'

const InterimModal: FunctionComponent<{ type: 'loading' | 'error'; onClick: () => void }> = ({ type, onClick }) => {
  const { t } = useTranslation()

  return (
    <div className="modal-container article">
      <div id="pubModal" role="dialog" aria-label="Publikation" aria-modal="true">
        <div className="publication-dialog">
          <div className="content content__feedback">
            <header>
              <div className="pub-icon-button close">
                <button onClick={onClick}>
                  <span className="btn-gfx"></span>
                  <span className="text">{t('close')}</span>
                </button>
              </div>
            </header>
            <div className="message">
              <p className="preamble">{type === 'loading' ? t('loading') : t('something-went-wrong')}</p>
              {type === 'loading' ? <div className="loading-bar" /> : null}
              <button className="btn btn-primary" onClick={onClick}>
                {t('close')}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default InterimModal
